import { mapGetters } from "vuex"

// import phases_utilities from './PhasesUtilities'
import has_addresses from "../../../mixins/HasAddresses"
import string_utilities from "../../../mixins/StringUtilities"
import ui_utilities from "../../../mixins/UiUtilities"

const wizard_target = {
    // mixins: [phases_utilities, has_addresses],
    mixins: [string_utilities, ui_utilities, has_addresses],
    methods: {
        has_required_data (data_id) {
            if(!this.record) return false
            if(data_id === "category_ids") return !!this.record.category_ids && !!this.record.category_ids.length
            if(data_id === "size") {
                if(this.wizard_ignore_project_size) return true
                return !!this.record.size && !!parseFloat(this.record.size)
            }
            if(data_id === "address") {
                const physical_address = this.physical_address("App\\Project", this.record.id)
                return !!physical_address && !!physical_address.city
            }
            // if(data_id === "start_date") return !!this.record.projected_starts_at
            if(data_id === "main_contact") return !!this.main_contact_project
            if(data_id === "phase_fees") return !!this.phases.length && !this.phases.filter(phase => phase.prospective_fee === 0).length
            if(data_id === "phase_dates") return !!this.phases.length && !this.phases.filter(phase => !phase.starts_at || !phase.ends_at).length

            return false
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_contact_records () {
            return this.entity_records("contact_project")
        },
        raw_phase_records () {
            return this.entity_records("phase")
        },
        phases () {
            if(!this.record || !this.record.id) return []
            return this.raw_phase_records.filter(phase => phase.project_id === this.record.id)
        },
        wizard_ignore_project_size () {
            if(this.page_wizard) {
                if(this.page_wizard === "declined") return true
                if(this.page_wizard === "dead") {
                    const type_of_request = this.types_of_request.find(type_of_request => type_of_request.id === this.record.type_of_request)
                    if(type_of_request && (type_of_request.code_constant === "architect")) return true
                }
            }
            return false
        },
        main_contact_project () {
            if(!this.record || !this.record.id) return null
            return this.raw_contact_records.find(contact_project => (contact_project.internal_category === "main") && (contact_project.project_id === this.record.id))
        },
        types_of_request () {
            return this.dictionary("type_of_request")
        }
    },
    data () {
        return {
            page_wizard: null
        }
    }
}

export default wizard_target
